import { render, staticRenderFns } from "./StandardTemplate.vue?vue&type=template&id=6dc764b6&scoped=true&"
import script from "./StandardTemplate.vue?vue&type=script&lang=js&"
export * from "./StandardTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc764b6",
  null
  
)

export default component.exports